// extracted by mini-css-extract-plugin
export default {"Prline":"prline_Prline__dd+fi","Prline__new":"prline_Prline__new__i9KJn"};